if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * Toggle
         * Toggle content
         *
         * Expects HTML:
         * <a href="#id-of-target" [or] data-target="id-of-target" data-interaction="Toggle"></a>
         * <sometag id="id-of-target"></sometag>
         *
         * @trigger can have the following attributes:
         * data-target     = id_of_target
         *    or: href     = #id_of_target -- note: with hash
         * data-init       = [open | closed] -- initial state of target (default 'open')
         * data-toggle-all = [open | close | openclose] -- use trigger to toggle all toggles within target (default undefined)
         * data-hide       = id_of_target_to_hide -- hide specific content on first toggle
         */
        ZZ.Toggle = function(trigger, target) {
            this.trigger = trigger || $();
            this.target = target || this.getTarget();

            this.config = $.extend(
                {},
                this._defaultConfig,
                this.trigger.data()
            );

            this.initState = this.trigger.attr("data-init") || "open";
            this.triggerAll = false;
            if (typeof this.trigger.attr("data-toggle-all") !== "undefined") {
                this.triggerAll = this.trigger.attr("data-toggle-all");
            }

            this.assignListeners();

            if (this.initState === "closed" && !this.triggerAll) {
                this.target.css("display", "none");
                this.trigger.addClass("closed");
                this.target.addClass("closed");
            } else if (this.initState === "closed" && this.triggerAll) {
                this.triggerAll();
            }
        };

        ZZ.Toggle.prototype = {
            _defaultConfig: {
                toggleAnimDuration: 300
            },

            getTarget: function(trigger) {
                var curTrigger = trigger || this.trigger;
                if (typeof curTrigger.attr("data-target") !== "undefined") {
                    return $("#" + curTrigger.attr("data-target"));
                } else if (typeof curTrigger.attr("href") !== "undefined") {
                    return $(curTrigger.attr("href"));
                } else {
                    return $();
                }
            },

            assignListeners: function() {
                var base = this;
                this.trigger.on("click.toggle", function(e) {
                    e.preventDefault();

                    if (!base.triggerAll) {
                        base.toggle();
                    } else {
                        base.toggleAll();
                    }
                });
            },

            // @param openclose = 'open' || 'close'
            toggle: function(target, openclose) {
                var base = this,
                    curTarget = target || this.target,
                    animSpeed = base.config.toggleAnimDuration,
                    inputs = curTarget.find(":input");

                /*als er binnen de toggle target er een form is met een reset button welke de target weer dicht moet toggle
                de form waar de reset button dan in staat wordt gereset */

                if (this.trigger.attr("type") === "reset") {
                    var form = this.trigger.parents("form");
                    form[0].reset();
                }

                // reset inputs when target closes
                if (!curTarget.hasClass("closed")) {
                    base.resetInput(inputs);
                }

                if (openclose === "close" && curTarget.hasClass("closed")) {
                    return false;
                } else if (
                    openclose === "open" &&
                    !curTarget.hasClass("closed")
                ) {
                    return false;
                } else if (!curTarget.is(":animated")) {
                    curTarget.slideToggle(animSpeed);
                    curTarget.toggleClass("closed");

                    // look for all triggers (multiple Toggle triggers can have the same target)
                    var curTargetId = curTarget.attr("id");
                    var allTriggers = $(
                        "[data-interaction*=Toggle][href='#" +
                            curTargetId +
                            "'], [data-interaction*=Toggle][data-target='" +
                            curTargetId +
                            "']"
                    );
                    allTriggers.toggleClass("closed");

                    // animate to target if target is not visible in current view
                    base.scrollIntoView(curTarget);

                    // focus on first text form field if openend
                    if (!this.trigger.hasClass("closed")) {
                        this.target
                            .find("input, select, textarea")
                            .first()
                            .focus();
                    }

                    // hide content, if specified via data-hide attribute
                    if (typeof this.trigger.attr("data-hide") !== "undefined") {
                        var elemId =
                            this.trigger.attr("data-hide").indexOf("#") === 0
                                ? this.trigger.attr("data-hide")
                                : "#" + this.trigger.attr("data-hide");
                        $(elemId).hide(animSpeed);
                    }

                    return true;
                }
            },

            toggleAll: function() {
                var allTriggers = this.target.find(
                        '[data-interaction="Toggle"]'
                    ),
                    allTriggersLength = allTriggers.length,
                    i = 0,
                    curTarget,
                    curTrigger;
                for (i; i < allTriggersLength; i++) {
                    curTrigger = $(allTriggers[i]);
                    curTarget = this.getTarget(curTrigger);
                    if (this.toggle(curTarget, this.triggerAll)) {
                        curTrigger.toggleClass("closed");
                    }
                }
            },

            scrollIntoView: function(target) {
                var base = this;
                var curTarget = target || this.target;
                if (
                    curTarget.offset().top >
                        $(window).scrollTop() + $(window).height() ||
                    curTarget.offset().top < $(window).scrollTop()
                ) {
                    if (!base.trigger.hasClass("closed")) {
                        $("html, body").animate(
                            {
                                scrollTop: curTarget.offset().top
                            },
                            1000
                        );
                    }
                }
            },

            resetInput: function(inputs) {
                var base = this,
                    curTag,
                    curInput,
                    initVal;

                inputs.each(function() {
                    curTag = this.tagName.toLowerCase();
                    curInput = $(this);

                    // don't reset value of radiobuttons, checkboxes, hidden inputs or submit buttons
                    if (
                        curTag === "input" &&
                        !curInput.is(":radio") &&
                        !curInput.is(":checkbox") &&
                        curInput.attr("type") !== "hidden" &&
                        curInput.attr("type") !== "submit"
                    ) {
                        initVal = this.getAttribute("value") || "";
                        curInput.val(initVal);

                        // trigger change for interaction attached to specific input
                        curInput.trigger("change");
                    } else if (curTag === "select") {
                        this.selectedIndex = 0;

                        // trigger change for interaction attached to specific input
                        curInput.trigger("change");
                    }
                });
            },

            destroy: function() {
                this.trigger.off("click.toggle");
                this.trigger = null;
                this.target = null;
            }
        };
    })(jQuery);
}
